import type { ContentImage } from '../../types';

export default function isSvg(image: ContentImage | null): boolean {
  if (!image) {
    return false;
  }

  return image.fields.file.url.endsWith('.svg');
}
